export default "__VITE_PUBLIC_ASSET__675df64c__"